import { render, staticRenderFns } from "./PaytableSection.vue?vue&type=template&id=67e929c5&scoped=true&"
import script from "./PaytableSection.vue?vue&type=script&lang=ts&"
export * from "./PaytableSection.vue?vue&type=script&lang=ts&"
import style0 from "./PaytableSection.vue?vue&type=style&index=0&id=67e929c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e929c5",
  null
  
)

export default component.exports